import "./Header.scss";
import headerImg from "/src/app/assets/header.png";
import qr from "/src/app/assets/qr-new.png";
import {useUserStore} from "../../../../../modules/shop/user/store";
import {useI18n} from "../../../../i18n/I18nProvider";

const Header = () => {
    const user = useUserStore(state => state.user)
    const { t } = useI18n()

    return (
        <header>
            <img className="header-img" alt="header" src={headerImg}/>
            <div className="header-info">
                <div className="user-info">
                    {
                        user.personaName ? <>
                            <img className="avatar-user"
                                 src={ user.avatarUrl }
                                 alt="avatar"
                            />
                            <div>
                                <div className="user-block gap12">
                                    <h3 className="user-name">
                                        <strong>{ user.personaName }</strong>
                                    </h3>
                                </div>
                                {
                                    user.personalBonus > 0 ?
                                        <div className="user-title">
                                            {t("header.bonus", { n: user.personalBonus })}
                                        </div>
                                        :
                                        <div className="user-title">
                                            {t("header.noBonus")}
                                        </div>
                                }
                            </div>
                        </>
                            :
                            <div className="header-info-block">
                                <p className="header-info-block-item">{t("header.donateInfo")}</p>
                                {/*<p className="header-info-block-item"><span>Пожертвования не подлежат возврату.</span></p>*/}
                            </div>
                    }
                </div>
                <div className="header-qr">
                    <img src={qr} alt="qr" width={120} height={120} className="qr-img"/>
                </div>
            </div>
        </header>
    );
};

export default Header;